import React from 'react';
import {View} from 'react-native';

import Text from '/component/base/Text';
import {DownlineProfile} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from '../TaskDetails.style';
import {TaskDetailsContent} from '../TaskDetailsContent';

export const FirstWeekCelebrationDetails = () => {
  const {ts} = useTranslation(
    'clientProfile.clientJourney.firstWeek.FirstWeekCelebration',
  );
  return (
    <>
      <View style={styles.taskDetailContent}>
        <View style={styles.firstWeekCelebrationContent}>
          <Text
            variant="button"
            style={styles.taskDetailContentText}
            {...testProperties(DownlineProfile.cjTaskDetailsText)}>
            {ts(
              'details',
              'Celebrate your Client’s milestone and continue supporting them as they keep up the healthy habits they’ve started to form.',
            )}
          </Text>
        </View>
        <TaskDetailsContent
          taskDetailsList={[
            ts(
              'detailsListItem1',
              'Introduce your Client to your Training Coach or Support Team Member and share their success.',
            ),
          ]}
          style={{base: styles.firstWeekCelebrationListItemContainer}}
        />
        <View style={styles.firstWeekCelebrationContent}>
          <Text
            variant="button"
            style={styles.taskDetailContentText}
            {...testProperties(DownlineProfile.cjTaskDetailsSecondText)}>
            {ts(
              'detailsList',
              'Introduce your Training Coach to your Client, they will lead the conversation and likely cover:',
            )}
          </Text>
        </View>

        <TaskDetailsContent
          taskDetailsList={[
            ts(
              'detailsListItem1',
              'Encouraging them to add their name in their LifeBook and take a look at the first 5-6 pages.',
            ),
            ts(
              'detailsListItem2',
              'How to refer people who might be inspired by your health journey and want to get healthy themselves.',
            ),
            ts('detailsListItem3', ' Recap next steps.'),
          ]}
          style={{
            base: styles.firstWeekCelebrationListItemContainer,
            listItem: styles.journeyKickOffCallListItem,
          }}
        />
      </View>
    </>
  );
};
